<template>
	<div>
		<v-row class="body-transaction-product body-transaction-product-sm">
			<v-col cols="12" sm="12" md="12" lg="10" class="">
				<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
					<v-row>
						<v-col cols="12" sm="8" class="my-auto">
							<v-form ref="formSerial">
								<div class="d-flex flex-wrap" v-for="(input, i) in zeroData" :key="i">
									<v-col cols="5" class="pt-0">
										<v-text-field hide-details="auto" label="Kode Serial" :rules="rules.serial" v-model="input.serial"></v-text-field>
										<div class="pt-1 font-size-9 red--text text--lighten-2" v-if="input.transaction_serial_msg">{{ input.transaction_serial_msg }}</div>
									</v-col>
									<v-col cols="5" class="pt-0">
										<v-text-field hide-details="auto" label="Pin Serial" :rules="rules.pin" v-model="input.pin"></v-text-field>
										<div class="pt-1 font-size-9 red--text text--lighten-2" v-if="input.transaction_serial_pin_msg">{{ input.transaction_serial_pin_msg }}</div>
									</v-col>
									<v-col cols="2" class="py-0 my-auto" v-if="zeroData.length > 1">
										<v-btn x-small depressed fab color="red lighten-2 white--text" @click="delInput(input.id)">
											<v-icon small>mdi-delete</v-icon>
										</v-btn>
									</v-col>
								</div>
							</v-form>
						</v-col>
						<v-col cols="12" sm="4" class="text-left">
							<div class="font-size-11 cl-dark-green mb-2">Tambah Input Serial</div>
							<template>
								<v-btn small depressed color="teal lighten-2 white--text" class="ml-1 rounded-pill" @click="addInput(1)">
									<v-icon small>mdi-plus</v-icon>
									<span class="pl-1 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">1</span>
								</v-btn>
								<v-btn small depressed color="teal lighten-2 white--text" class="ml-1 rounded-pill" @click="addInput(5)">
									<v-icon small>mdi-plus</v-icon>
									<span class="pl-1 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">5</span>
								</v-btn>
								<v-btn small depressed color="teal lighten-2 white--text" class="ml-1 rounded-pill" @click="addInput(10)">
									<v-icon small>mdi-plus</v-icon>
									<span class="pl-1 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">10</span>
								</v-btn>
							</template>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>

		<div class="footer-transaction-product rounded-xl">
			<div class="d-flex flex-wrap">
				<v-col cols="12" sm="12" class="pa-0 text-right">
					<v-btn large width="130" depressed color="grey lighten-3" class="rounded-pill" @click="showModalBack">
						<v-icon>mdi-arrow-left</v-icon>
						<span class="pl-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Kembali</span>
					</v-btn>
					<v-btn large width="120" depressed color="primary" class="ml-2 rounded-pill" :disabled="zeroData.length == 0" :loading="btn_loading" @click="nextStep">
						<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Lanjut</span>
						<v-icon>mdi-arrow-right</v-icon>
					</v-btn>
				</v-col>
			</div>
		</div>
		<ModalBack ref="modalBack" :msg="msgBack" @action="processBack"></ModalBack>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalBack from '@/components/modals/vo/ModalConfirm';

export default {
	components: {
		ModalBack
	},
	props: {
		ispremiumtype: Boolean,
		ropos: String
	},
	data() {
		return {
			zeroData: [
			{
				id: 0,
				serial: '',
				pin: '',
				transaction_serial_msg: '',
				transaction_serial_pin_msg: '',
			}
			],
			params: {},
			serialId: 1,
			btn_loading: false,
			rules: {
				serial: [v => !!v || 'Kode Serial tidak boleh kosong'],
				pin: [v => !!v || 'Pin Serial tidak boleh kosong'],
			},
			msgBack: 'Jika kembali Anda harus mengulangi proses Input Repeat Order. Yakin ingin kembali?',
		}
	},
	computed: {
		...mapState('transactionProduct', ['errorSerial']),
	},
	methods: {
		...mapActions('transactionProduct', ['checkSerialRO', 'checkSerialROPremium']),

		showModalBack() {
			this.$refs.modalBack.modalShow()
		},
		processBack() {
			this.$router.push({name: 'input-repeat-order'})
		},
		addInput(val) {
			for (let i = 0; i < val; i++) {
				this.zeroData.push({
					id: this.serialId,
					serial: '',
					pin: '',
					transaction_serial_msg: '',
					transaction_serial_pin_msg: '',
				})
				this.serialId++
			}
		},
		delInput(index) {
			this.zeroData = this.zeroData.filter(function(item) {
				return item.id !== index
			})
		},
		nextStep() {
			if (this.$refs.formSerial.validate()) {
				this.btn_loading = true
				this.params = {}
				this.params.transaction_serial = []
				this.params.transaction_serial_pin = []
				this.zeroData.forEach((el) => {
					if ( el.serial && el.pin ) {
						this.params.transaction_serial.push(el.serial)
						this.params.transaction_serial_pin.push(el.pin)
					}
				})

				if (this.ispremiumtype) {
					this.checkSerialROPremium(this.params).then(() => {
						this.$emit('action', this.zeroData)
						this.btn_loading = false
					}).catch(() => {
						this.btn_loading = false
						this.zeroData.map((el, index)=>{
							let err_index = this.errorSerial[index]
							el.transaction_serial_msg = err_index.transaction_serial
							el.transaction_serial_pin_msg = err_index.transaction_serial_pin
						})
					})
				} else {
					this.checkSerialRO(this.params).then(() => {
						this.$emit('action', this.zeroData)
						this.btn_loading = false
					}).catch(() => {
						this.btn_loading = false
						this.zeroData.map((el, index)=>{
							let err_index = this.errorSerial[index]
							el.transaction_serial_msg = err_index.transaction_serial
							el.transaction_serial_pin_msg = err_index.transaction_serial_pin
						})
					})
				}
			}
		}
	},
	created() {
	},
};
</script>